export enum Personas {
  STAFF = "STAFF",
  NONE = "NONE",
  FULL_TIME_EMPLOYEE = "FULL_TIME_EMPLOYEE",
  CONTRACTOR = "CONTRACTOR",
  COMPANY_ADMIN = "COMPANY_ADMIN",
  MANAGER = "MANAGER",
}

export enum AccountAspectType {
  COMPANY = "Company",
  EMPLOYEE = "Employment",
  CONTRACT = "Contract",
  STAFF = "Staff",
  NONE = "None",
}
